module.exports = __webpack_public_path__ + "static/media/product6.b7614d23.jpg";